/* unplugin-vue-components disabled */import script from "./Dialog.vue?vue&type=script&setup=true&lang=js"
export * from "./Dialog.vue?vue&type=script&setup=true&lang=js"

import "./Dialog.vue?vue&type=style&index=0&id=203b43e3&lang=scss"

const __exports__ = script;

export default __exports__